/**
 * Brand loading indicator — the StackSketch mark with a gentle "breathing" pulse.
 * A calm, on-brand alternative to a spinner. The animation (`.ss-breathe`) is a
 * CSS keyframe in index.css and is disabled under prefers-reduced-motion.
 */
export function BrandLoader({ label, className }: { label?: string; className?: string }) {
  return (
    <div className={`flex flex-col items-center gap-3 ${className ?? ''}`}>
      <img src="/StackSketch-IconLogo.svg" alt="" className="ss-breathe h-11 w-11" />
      {label && <p className="text-sm text-muted-foreground">{label}</p>}
    </div>
  );
}
